module.exports = __webpack_public_path__ + "img/buy_normal_zh.b54ea7a3.png";